import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import possibilityImage from '../../assets/team.png';
import slider1 from '../../assets/place4.jpeg';
import slider2 from '../../assets/place2.jpg';

import './index.css';

const Index = () => (
  <div className="gpt3__possibility section__padding">
    <div className="gpt3__possibility-content">
      <h1 className="gradient__text">We are Visitor Advisor family</h1>
      <p>Yet bed any for travelling assistance indulgence unpleasing. Not thoughts all exercise blessing. Indulgence way everything joy alteration boisterous the attachment. Party we years to order allow asked of.</p>
      <h4>Request Early Access to Get Started</h4>
    </div>
    <div className="gpt3__features-container__feature-title">
      <div />
      <h1>FIND A PLACE</h1>
    </div>
    <div className="gpt3__possibility-image">
      <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
        <div>
          <img src={possibilityImage} />
          <p className="legend">Type your place name</p>
        </div>
        <div>
          <img src={slider1} />
          <p className="legend">Select a place </p>
        </div>
        <div>
          <img src={slider2} />
          <p className="legend">View title</p>
        </div>
      </Carousel>
    </div>
  </div>
);

export default Index;
